import { useCallback, useState } from "react";

type ReturnType = (defaultState?: boolean) => {
	handleClose: () => void;
	handleOpen: () => void;
	isOpen: boolean;
};

export const useOpenHandler: ReturnType = (defaultState = false) => {
	const [isOpen, setIsOpen] = useState<boolean>(defaultState);
	const handleOpen = useCallback(() => {
		setIsOpen(true);
	}, []);
	const handleClose = useCallback(() => {
		setIsOpen(false);
	}, []);
	return { handleClose, handleOpen, isOpen };
};
